import { render, staticRenderFns } from "./ReglamentoNewOrEdit.vue?vue&type=template&id=577c6046&"
import script from "./ReglamentoNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./ReglamentoNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReglamentoNewOrEdit.vue?vue&type=style&index=0&id=577c6046&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports